import React, { useMemo } from 'react'
import { useSearchParams } from 'react-router'
import { useLogto } from '@logto/react'
import { Page } from '../../layout/Page.tsx'
import Card from '../../newComponents/Card/Card.tsx'

const SignIn: React.FC = () => {
	const { signIn } = useLogto()
	const [searchParams] = useSearchParams()
	const isDevEnvironment = useMemo(() => {
		return location.hostname === 'localhost'
	}, [])

	const redirect = searchParams.get('redirect')
	localStorage.removeItem('organicSignOut')
	if (redirect) {
		localStorage.setItem('postLoginRedirect', redirect)
	}

	return (
		<Page title="Sign In">
			<div className="w-[100%] min-h-dvh p-7 flex justify-center items-center">
				<div className="max-w-100">
					<Card>
						<h2 className="text-center mb-9 text-2xl font-semibold text-black dark:text-white">Sign in to NextPeak</h2>
						<button
							onClick={() => signIn(isDevEnvironment ? import.meta.env.VITE_LOCAL_REDIRECT_URL : import.meta.env.VITE_PROD_REDIRECT_URL)}
							className="w-full cursor-pointer rounded-lg bg-brand-500 shadow-theme-xs hover:bg-brand-600 disabled:bg-brand-300 p-4 font-medium text-white transition"
						>
							Sign In
						</button>
					</Card>
				</div>
			</div>
		</Page>
	)
}

export default SignIn
